export const STATUS_DISPARO_CLASSE: Record<string, string> = {
  'Aguardando Envio': 'cor-verde-escura',
  'Processando': 'cor-laranja',
  'Em fila': 'cor-roxa',
  'Enviado': 'cor-verde-clara',
  'Cancelado': 'cor-vermelho',
  'Erro': 'cor-vermelho',
  'Agendado': 'cor-azul-claro',
  'Recorrente': 'cor-roxa',
  'Buscando base': 'cor-ragazzi',
  'Limite atingido': 'cor-limite-atingido',
  'Pausado': 'cor-ragazzi',
};

export function classeStatusDisparo(status?: string | null): string {
  return status ? (STATUS_DISPARO_CLASSE[status] ?? '') : '';
}

export interface OpcaoStatusDisparo {
  id: string;
  nome: string;
}

export const STATUS_DISPARO_OPCOES: OpcaoStatusDisparo[] = [
  { id: 'ENVIADO', nome: 'Enviado' },
  { id: 'EM_FILA', nome: 'Em fila' },
  { id: 'PROCESSANDO', nome: 'Processando' },
  { id: 'AGUARDANDO_ENVIO', nome: 'Aguardando Envio' },
  { id: 'AGENDADO', nome: 'Agendado' },
  { id: 'ERRO', nome: 'Erro' },
  { id: 'CANCELADO', nome: 'Cancelado' },
  { id: 'BUSCANDO_BASE', nome: 'Buscando base' },
  { id: 'LIMITE_ATINGIDO', nome: 'Limite atingido' },
  { id: 'PAUSADO', nome: 'Pausado' },
];
